/*
 * @Descripttion: 社团缴费标准 接口
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-04-22
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-04-25 22:06:30
 */

import http from '@/utils/kq/http';

const veStuAssocFundsStandardApi = {
  //添加接口
  add(data) {
    return http.post(http.service.stu + 'veStuAssocFundsStandard/add', data);
  },
  //删除接口
  delete(ids) {
    return http.delete(http.service.stu + 'veStuAssocFundsStandard/deleteBatch?ids=' + ids);
  },
  //修改接口
  update(data) {
    return http.put(http.service.stu + 'veStuAssocFundsStandard/edit', data);
  },
  //分页查询接口
  page(pageData) {
    return http.post(http.service.stu + 'veStuAssocFundsStandard/page', pageData);
  },
  //分页查询接口
  all(pageData) {
    return http.post(http.service.stu + 'veStuAssocFundsStandard/all', pageData);
  },
  //查询单个数据接口
  get(id) {
    return http.get(http.service.stu + 'veStuAssocFundsStandard/queryById', { id: id });
  },
  //更新状态
  updateStatus(data) {
    return http.post(http.service.stu + 'veStuAssocFundsStandard/updateStatus', data);
  }
};
export default veStuAssocFundsStandardApi;
